import React, {Component} from "react";
import { Col, Container, Row } from "react-bootstrap";
import userEventService from "../services/user-event.service";

interface PrivatePageState {
    productStatus: string;
    translations: Record<string, any>;
}

class PrivatePage extends Component<{}, PrivatePageState> {
    constructor(props: any) {
        super(props);
        this.state = {
            productStatus: '',
            translations: JSON.parse(localStorage.getItem('translations') || '[]')
        };
    }

    componentDidMount(): void {
        userEventService.sendEvent('page_view', 'private_page_open');
    }

    render() {
        return (
            <>
                <Container className="oc-mainpage">
                    <Row>
                        <Col key={'pageContent_completed'} lg={6} md={6} sm={12} xs={12}>
                            <h2>
                                {this.state.translations.filter((item: any) => item.setting_name === 'PRIVATE_BOAT')[0].setting_value_text}
                            </h2>
                            <p style={{ marginTop: '32px' }}>
                                {this.state.translations.filter((item: any) => item.setting_name === 'COMING_SOON')[0].setting_value_text}
                            </p>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

export default PrivatePage;